module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("jDUMe"))).then(() => parcelRequire('6y24F'));